<script>

	import request from "./request.vue";

	const sessionItems = [
		"token",
		"firstName",
		"lastName",
		"role",
		"email",
		"originalUrl",
		"id",
	];

	const setSessionData = (sessionData) => {
		// Irete over key, values from data incoming from server and deep find the items that would be saved in seesion storage
		Object.entries(sessionData).forEach(([key, value]) => {
			if (sessionItems.includes(key)) {
				sessionStorage.setItem(key, value);
			}

			if (value && typeof value === "object") {
				setSessionData(value);
			}
		});

		return true;
	};

	export default {
		setSessionData,
		isActive: async () => {
			let token = sessionStorage.getItem("token");
			let role = sessionStorage.getItem("role");
			let cookies = document.cookie;
			if(!cookies.includes("validToken=true")) {
				if (token && role === "ADMIN") {
					try {
						const response = await request.send("user", "validToken", null, true);
						if(response.success) {
							document.cookie = "validToken=true; max-age="+15 * 60+";"
							return true;
						}
						else return false	
					} catch (error) {
						return false;
					}
				}
			} else return true;
		},
		clear: () => {
			sessionStorage.clear();
			return true;
		},
		getItem: (sessionItem) => {
			if (sessionItems.includes(sessionItem)) {
				return sessionStorage.getItem(sessionItem);
			}
			throw Error("ERR_INVALID_SESSION_ITEM");
		},
		setItem: (sessionItem, value) => {
			if (sessionItems.includes(sessionItem)) {
				sessionStorage.setItem(sessionItem, value);
				return;
			}
			throw Error("ERR_INVALID_SESSION_ITEM");
		}
	}
</script>
